import { Divider as MuiDivider } from "@material-ui/core";

import { StylableProps } from "@rewards-web/shared/types";

interface DividerProps extends StylableProps {}

export function Divider({ className }: DividerProps): JSX.Element {
  return <MuiDivider className={className} />;
}
